'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _createReducer;

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = !!process.env.REACT_APP_SERVER;

function plansRequested(settingsState, _ref) {
  var builderId = _ref.builderId;

  return (0, _extends5.default)({}, settingsState, (0, _defineProperty3.default)({}, builderId, {
    isFetching: true,
    requestedOnServer: isServer
  }));
}

function plansLoaded(settingsState, _ref2) {
  var builderId = _ref2.builderId,
      data = _ref2.data,
      receivedAt = _ref2.receivedAt;

  return (0, _extends5.default)({}, settingsState, (0, _defineProperty3.default)({}, builderId, (0, _extends5.default)({}, settingsState[builderId], {
    isFetching: false,
    data: data,
    receivedAt: receivedAt
  })));
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _actions.REQUEST_PLANS, plansRequested), (0, _defineProperty3.default)(_createReducer, _actions.RECEIVE_PLANS, plansLoaded), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Plans/reducer.js
// module id = 950
// module chunks = 0